export default __webpack_public_path__ + "static/media/929.74c6d551.png";